'use strict';

/* eslint-disable */
module.exports = function () {

  /*
    Given absolute values 1-100, convert to relative values 0-1
   */
  exports.calculateIncreaseMultipliers = function (matrix, valuationBuckets, payBuckets) {
    var maxSlider = 0;

    var minValuationSlider = 500;
    for (var bucketCnt = 0; bucketCnt < valuationBuckets.length; bucketCnt++) {
      var bucket = valuationBuckets[bucketCnt];
      if (bucket.rawSliderValue > maxSlider) {
        maxSlider = bucket.rawSliderValue;
      }
      if (bucket.rawSliderValue < minValuationSlider) {
        minValuationSlider = bucket.rawSliderValue;
      }
    }

    var minPaySlider = 500;
    for (var _bucketCnt = 0; _bucketCnt < payBuckets.length; _bucketCnt++) {
      var _bucket = payBuckets[_bucketCnt];
      if (_bucket.rawSliderValue > maxSlider) {
        maxSlider = _bucket.rawSliderValue;
      }
      if (_bucket.rawSliderValue < minPaySlider) {
        minPaySlider = _bucket.rawSliderValue;
      }
    }

    calculateSingleBucketIncreaseMultipliers(valuationBuckets, matrix.performanceBudgetAllocation, maxSlider, minValuationSlider);
    calculateSingleBucketIncreaseMultipliers(payBuckets, matrix.payBudgetAllocation, maxSlider, minPaySlider);

    return {
      maxSlider: maxSlider
    };
  };

  /*
   Given a slider increase multiplier, adjust for bucket multiplier
   */
  var calculateSingleBucketIncreaseMultipliers = function calculateSingleBucketIncreaseMultipliers(buckets, bucketIncreaseMultiplier, maxSlider, minSlider) {
    // normalize the min slider to 0-1
    var minSliderAdjusted = minSlider / maxSlider;

    for (var bucketCnt = 0; bucketCnt < buckets.length; bucketCnt++) {
      var bucket = buckets[bucketCnt];
      // normalize to 0-1
      bucket.increaseMultiplier = bucket.rawSliderValue / maxSlider;

      var diffToMin = bucket.increaseMultiplier - minSliderAdjusted;

      // adjust normalization to account for pay vs valuation overall affect goal
      bucket.increaseMultiplier = minSliderAdjusted + diffToMin * bucketIncreaseMultiplier;
    }
  };

  /*
    Main function for matrix pay increase calculations
   */
  exports.calculate = function (matrix, matrixCells, valuationBuckets, payBuckets) {
    // console.log('matrix: ', matrix);
    // console.log('cells: ', matrixCells);
    // console.log('perf buckets: ', valuationBuckets);
    // console.log('pay buckets: ', payBuckets);

    applyBucketDataToCells(matrixCells, valuationBuckets, payBuckets);

    cellTargetPct(matrix, matrixCells);

    cellActualIncrease(matrix, matrixCells);

    // console.log('first cell', matrixCells[0], 'matrix', matrix);

    return matrixCells;
  };

  /*
    De-normalize data for the entire row/column into each cell to simplify code
   */
  var applyBucketDataToCells = function applyBucketDataToCells(matrixCells, valuationBuckets, payBuckets) {
    for (var cellCnt = 0; cellCnt < matrixCells.length; cellCnt++) {
      var cell = matrixCells[cellCnt];

      for (var valuationBucketCnt = 0; valuationBucketCnt < valuationBuckets.length; valuationBucketCnt++) {
        var bucket = valuationBuckets[valuationBucketCnt];
        if (cell.performanceBucket === bucket.name) {
          cell.valuationIncreaseMultiplier = bucket.increaseMultiplier;
        }
      }

      for (var payBucketCnt = 0; payBucketCnt < payBuckets.length; payBucketCnt++) {
        var _bucket2 = payBuckets[payBucketCnt];
        if (cell.payBucket === _bucket2.name) {
          cell.payIncreaseMultiplier = _bucket2.increaseMultiplier;
        }
      }
    }
  };

  /*
    Calculate the overall influence/% to direct dollars to each cell
    This is currently by employee count but will support payroll % as an alternative method
   */
  var cellTargetPct = function cellTargetPct(matrix, matrixCells) {
    var sumTargetIncrease = 0;

    // calculate target pct increase in each cell
    for (var cellCnt = 0; cellCnt < matrixCells.length; cellCnt++) {
      var cell = matrixCells[cellCnt];
      var targetPct = 0;

      // no increase if no ees
      if (cell.employeeCount === 0) {
        cell.targetPct = 0;
        continue;
      }

      var totMultiplier = cell.valuationIncreaseMultiplier * cell.payIncreaseMultiplier;

      var cellEERatio = cell.employeeCount / matrix.employeeCount;

      targetPct = totMultiplier * cellEERatio;

      sumTargetIncrease += targetPct;

      cell.targetEEPct = targetPct;
    }

    var overallTargetIncrease = 0;
    if (sumTargetIncrease > 0) {
      overallTargetIncrease = matrix.budgetIncreasePercent / sumTargetIncrease;
    }
    matrix.overallTargetIncrease = overallTargetIncrease;
    // console.log('sumTargetIncrease', sumTargetIncrease, 'overallTargetIncrease', overallTargetIncrease);

    return matrixCells;
  };

  /*
    Figure out the actual %/$ pay increase for each cell
   */
  var cellActualIncrease = function cellActualIncrease(matrix, matrixCells) {
    // calculate target pct increase in each cell
    for (var cellCnt = 0; cellCnt < matrixCells.length; cellCnt++) {
      var cell = matrixCells[cellCnt];

      var totMultiplier = cell.valuationIncreaseMultiplier * cell.payIncreaseMultiplier;
      cell.payIncreasePct = matrix.overallTargetIncrease * totMultiplier;
      cell.payIncreaseDollars = cell.payIncreasePct * cell.baseSalarySum;
    }
  };

  exports.employeeEffect = function (matrixCells, employees) {};

  exports.applyPresetValues = function (buckets) {
    var preset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'moderate';

    //for now just using linear slopes for an n number of x values

    // All of these constants are multiplied by 5 since the upper
    // scale is now 500 rather than 100. I'm doing multiplication 
    // inline so that this is clear that it's scaling up the percent
    // instead of just looking like magic numbers
    var performancePresets = {
      conservative: function conservative(x, count) {
        return -10 * 5 * (x / count) + 55 * 5;
      },
      moderate: function moderate(x, count) {
        return -50 * 5 * (x / count) + 75 * 5;
      },
      aggressive: function aggressive(x, count) {
        return -90 * 5 * (x / count) + 95 * 5;
      }
    };

    var payBucketPresets = {
      conservative: [60, 55, 50, 45, 40].map(function (n) {
        return n * 5;
      }),
      moderate: [70, 56, 46, 37, 30].map(function (n) {
        return n * 5;
      }),
      aggressive: [95, 60, 35, 15, 5].map(function (n) {
        return n * 5;
      })
    };

    var performanceBuckets = buckets.performanceBuckets.map(function (bucket, x) {
      var xCount = buckets.performanceBuckets.length;
      bucket.rawSliderValue = performancePresets[preset](x, xCount);
      return bucket;
    });

    var payBuckets = buckets.payBuckets.map(function (bucket, index) {
      bucket.rawSliderValue = payBucketPresets[preset][index];
      return bucket;
    });

    return { performanceBuckets: performanceBuckets, payBuckets: payBuckets };
  };

  return exports;
};
